"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addCharToStr = void 0;
/**
 * Función que a partir de un string, genera otro de tal manera que cada cierta cantidad de caracteres
 * agrega un caracter. Opcionalmente se puede agregar un separador adicional al final del string.
 * @param {string} str String original
 * @param {char} separator Caracter insertado.
 * @param {number} period Cantidad de caracteres cada cuanto se desea agregar el separador
 * @param {char} additionalSeparator Separador del caracter adicional. Obligatorio en caso de que el argumento additionalSeparator esté definido.
 * @param {char} additional Caracter adicional
 * @returns {string}
 */
var addCharToStr = function (str, separator, period, additionalSeparator, additional) {
    if (additionalSeparator === void 0) { additionalSeparator = null; }
    if (additional === void 0) { additional = null; }
    var stack = [];
    for (var i = 0; i < str.length; i += 1) {
        if (i % period === 0 && i !== 0) {
            stack.unshift(separator);
        }
        stack.unshift(str.charAt(str.length - 1 - i));
    }
    if (additional) {
        stack.push(additionalSeparator, additional);
    }
    return stack.join('');
};
exports.addCharToStr = addCharToStr;
